import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quick-look',
  templateUrl: './quick-look.component.html',
  styleUrls: ['./quick-look.component.css']
})
export class QuickLookComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
